import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useAuth } from "../../context/AuthContext";

const AccountSection = ({ onClose }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) return null;

  const role = user?.employee?.role ?? user?.role;

  const accountLinks = [
    (role === "admin" || role === "manager" || role === "staff") && {
      label: "Admin Dashboard",
      path: "/admin/dashboard",
    },
    { label: "My Account", path: "/account" },
    { label: "My Orders", path: "/order-history" },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", px: 2.5 }}>
        <Box sx={{ width: 24, display: "flex", justifyContent: "center" }}>
          <PersonOutlineOutlinedIcon
            fontSize="small"
            sx={{ color: "#FD7762" }}
          />
        </Box>
        <Typography
          variant="subtitle2"
          sx={{
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "16px",
            letterSpacing: 0.5,
            color: "#FD7762",
            ml: 1,
          }}>
          Account
        </Typography>
      </Box>

      <Box sx={{ px: 3 }}>
        {accountLinks.map(({ label, path }) => (
          <Box
            key={label}
            onClick={() => {
              navigate(path);
              onClose();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1.1,
              borderRadius: 2,
              cursor: "pointer",
              color: "#1A1A1A",
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#FD7762",
                backgroundColor: "#FAFAFA",
                transform: "translateX(2px)",
              },
            }}>
            <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AccountSection;
